// extracted by mini-css-extract-plugin
export default {"productDescription":"Yaa-z","featuredDescription":"Zaa-z","description":"_aa-z","more":"aba-z","descriptionSku":"bba-z"};